/*=========================================================================================
  File Name: moduleLegalEntityMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  UPDATE_LEGAL_ENTITY(state: any, legalEntity: Object) {
    state.legalEntity = legalEntity
  }
}
